type BreakpointsLookup = {
  SM: boolean
  MD: boolean
  LG: boolean
  XL: boolean
}

export enum Breakpoints {
  XS = 320,
  SM = 576,
  MD = 768,
  LG = 992,
  XL = 1200,
}

export type WindowSize = {
  width: number
  height: number
}

export type WindowBreakpoints = {
  min: BreakpointsLookup
  max: BreakpointsLookup
}

export type LayoutResponsive = {
  windowSize: WindowSize
  breakpoints: WindowBreakpoints
  isSmallScreen: boolean
}

export const getDefaultContext = () => ({
  windowSize: getDefaultSize(),
  breakpoints: getBreakpoints(getDefaultSize()),
  isSmallScreen: false,
})

export const getDefaultSize = (isMobile = false): WindowSize => {
  if (isMobile) {
    return {
      width: Breakpoints.XS,
      height: Breakpoints.XS, // height is not important for breakpoints
    }
  } else {
    return {
      width: Breakpoints.XL + 1,
      height: Breakpoints.XL, // height is not important for breakpoints
    }
  }
}

export const getBreakpoints = (windowSize: WindowSize): WindowBreakpoints => {
  return {
    min: {
      SM: windowSize.width >= Breakpoints.SM,
      MD: windowSize.width >= Breakpoints.MD,
      LG: windowSize.width >= Breakpoints.LG,
      XL: windowSize.width >= Breakpoints.XL,
    },
    max: {
      SM: windowSize.width <= Breakpoints.SM,
      MD: windowSize.width <= Breakpoints.MD,
      LG: windowSize.width <= Breakpoints.LG,
      XL: windowSize.width <= Breakpoints.XL,
    },
  }
}
